import moment from "moment";
import { InventoryDealerUpdate } from "../../../types/inventory/updates-by-dealer/InventoryDealerUpdate";
import { isRequestSuccess } from "../../../utils/request-state.utils";
import { Table } from "../../bidding/common/table/Table";
import { IColumnDefinition } from "../../bidding/common/table/types/ColumnDefinition";
import { Preloader } from "../../common/Preloader";
import Popup from "../../controls/Popup";
import { PopupBody } from "../../controls/PopupBody";
import { PopupFooter } from "../../controls/PopupFooter";
import { useInventoryByDealerUpdates } from "./hooks/useInventoryByDealerUpdates";
import { constants } from "../../../constants/constants";
import { SORTING_TYPE } from "../../../constants/sort";
import { ColumnBuilder } from "../../bidding/common/table/columns/column-builder/ColumnBuilder";

interface Props {
    onClose(): void;
}

export function UpdatesByDealerPopup({ onClose }: Readonly<Props>) {
    const { requestState, dealerUpdates } = useInventoryByDealerUpdates();

    return (
        <Popup
            renderInBody
            title="Updates by Dealer"
            onClose={onClose}
            modalClass="updates-by-dealer-modal"
        >
            <PopupBody>
                <Preloader inProgress={!isRequestSuccess(requestState)}>
                    <Table
                        className="data-list-striped"
                        dataItems={dealerUpdates}
                        defaultSortBy="legalName"
                        columns={createColumns().map(c => new ColumnBuilder(c))}
                    />
                </Preloader>
            </PopupBody>
            <PopupFooter>
                <button className="btn btn-ghost" type="button" onClick={onClose}>Close</button>
            </PopupFooter>
        </Popup>
    )
}

function createColumns(): IColumnDefinition<InventoryDealerUpdate>[] {
    return [{
        columnKey: 'companyName',
        renderColumnHeaderContent: () => "Dealer",
        renderColumnContent: company => <span className="text-ellipsis">{company.legalName}</span>,
        sortingField: 'legalName',
        sortingType: SORTING_TYPE.string,
        className: 'data-list-cell-xl-01'
    }, {
        columnKey: 'companyCode',
        renderColumnHeaderContent: () => "Code",
        renderColumnContent: company => company.code,
        sortingField: 'code',
        sortingType: SORTING_TYPE.string,
        className: 'data-list-cell-xs-sm'
    }, {
        columnKey: 'lastUpdatedDate',
        renderColumnHeaderContent: () => "Last Updated",
        renderColumnContent: company =>  moment.utc(company.lastUpdateDate).format(constants.dateFormat),
        sortingField: 'lastUpdateDate',
        sortingType: SORTING_TYPE.date,
        className: 'data-list-cell-sm-01'
    }];
}
